import { createFileRoute, redirect } from "@tanstack/react-router";

// People type /signin out of habit; the sign-in page lives at /auth.
export const Route = createFileRoute("/signin")({
  beforeLoad: ({ search }) => { throw redirect({ to: "/auth", search, replace: true }); },
});
